export default "__VITE_ASSET__BVk3hieQ__"